module.exports = __webpack_public_path__ + "images/help/icn-faq-wechat@2x-6559562298d879fafea28e52569c4a97.png";